export namespace GXO {
  export const companyId = '2116ba52-e08e-4896-ba34-4c6a3fb0741f';

  export const supplierCustomFieldId = '86e593ac-93ed-44d5-9bb1-4a5595a120ba';
  export const purchaseOrderCustomFieldId = 'b3bcee40-0b50-47a0-adfd-c9c11c705a92';
  export const expectedDeliveryDateCustomFieldId = 'b59f6ceb-357a-45cf-bbf7-0d7e33de7a9b';
  export const carrierCustomFieldId = '0b813458-4948-4a0e-ad6b-40bb6b774b6a';
  export const trailerNoCustomFieldId = '6628476e-ba27-472d-98d5-b352e19b7f65';
  export const truckNumberCustomFieldId = '091161ce-ba4d-402c-87b6-19c681aa0e01';
  export const packingListNumberCustomFieldId = '68cc810d-7f62-442d-80d4-cbd9546f999b';
  export const totalPalletsCustomFieldId = 'f1b068f1-8a43-4622-8bdc-59d5434d0098';
  export const totalCartonsCustomFieldId = '9121f48d-d28a-4bfd-9728-da0c46646dff';
  export const documentationCustomFieldId = '9a827830-caa1-4da3-a422-d03d3b993df1';
  export const collectionDateCustomFieldId = '36606ab7-6d48-47b0-a019-91a9c90311f1';

  // Order Status
  export const expectedOrderStatusId = 'cdd7e0ca-8d5f-435d-bc76-dbe7fc3ac3b6';
  export const scheduledOrderStatusId = '42ef1501-5dfc-489a-9cfc-0f6b4381ebde';
  export const arrivedOrderStatusId = 'fc4f2b7f-b3ad-4366-9b33-46cbaf85b840';
  export const documentationReceivedOrderStatusId = '0f0094e1-70fc-4a8c-88a9-bf5094c4b8d7';
  export const unloadedOrderStatusId = '27ff9deb-8923-45ed-9df1-f79944cb6a71';
  export const checkingOrderStatusId = '4f6e726a-eecb-4c05-bcca-8d1eafb1d0a9';
  export const checkedOrderStatusId = '92d917a5-aa08-4139-9759-dc4c6a34b86d';
  export const putawayInProgressOrderStatusId = '9ffa9100-a0de-4280-ac59-bb40c74f3cae';
  export const receivedOrderStatusId = '69142408-9267-4110-8ee6-f0cb90f659e4';
  export const closedOrderStatusId = '2c694f24-fca3-48e1-bd57-8090b6293a2c';

  export const confirmCollectionDateOrderStatusId = '76652246-ed03-4ee4-8f9e-9d431fdce2ab';
  export const pickedOrderStatusId = '52334e65-9e8f-4824-bb9a-9b345cf48fc9';
  export const pickingOrderStatusId = '0a756ed4-962d-4faf-b76b-06c788f06d09';
}
